module.exports = __webpack_public_path__ + "static/media/cel1.690a7a63.png";